/** Set once per browser session: agreed that calls are translated and recorded. */
export const CONSENT_KEY = 'indusketch.callConsent';

/**
 * A call accepted from outside its project: the editor joins it once the project is open
 * and its live room has told whether the call still runs.
 */
let pending: string | null = null;

export const setPendingJoin = (projectId: string | null): void => {
  pending = projectId;
};

/** Takes the pending join for `projectId` (once). */
export function takePendingJoin(projectId: string): boolean {
  if (pending !== projectId) return false;
  pending = null;
  return true;
}
